/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Describes the overall scope resp. level of services.   (bipro-produktmodell::Paket)     * `Classic`   * `Premium`
 */
export const PrivateLiabilityPackage = {
  Classic: 'Classic',
  Premium: 'Premium',
} as const;
export type PrivateLiabilityPackage = (typeof PrivateLiabilityPackage)[keyof typeof PrivateLiabilityPackage];
